import { styled } from "@mui/material/styles";
import { PageView } from "@styleguide";

export const StyledPageView = styled(PageView)(({ theme }) => ({
  display: "flex",
  flexFlow: "row nowrap",
  [theme.breakpoints.down("tablet")]: {
    flexFlow: "column nowrap",
  },
}));
